var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C20 15.5229 15.5229 20 10 20C4.47715 20 0 15.5229 0 10ZM9.06977 14.186C9.06977 13.6723 9.48623 13.2558 10 13.2558H10.0084C10.5221 13.2558 10.9386 13.6723 10.9386 14.186C10.9386 14.6998 10.5221 15.1163 10.0084 15.1163H10C9.48623 15.1163 9.06977 14.6998 9.06977 14.186ZM9.06977 7.67442C9.06977 7.16067 9.48623 6.74419 10 6.74419C10.5138 6.74419 10.9302 7.16067 10.9302 7.67442C10.9302 7.861 10.8763 8.03213 10.7834 8.17646C10.6736 8.34716 10.5339 8.52716 10.3618 8.74102L10.2784 8.84428C10.134 9.0227 9.97088 9.22465 9.82214 9.42902C9.47237 9.90977 9.06977 10.5753 9.06977 11.3953C9.06977 11.9091 9.48623 12.3256 10 12.3256C10.5138 12.3256 10.9302 11.9091 10.9302 11.3953C10.9302 11.1879 11.0325 10.9277 11.3265 10.5236C11.4448 10.361 11.5725 10.203 11.7162 10.0251L11.8113 9.90735C11.9848 9.69154 12.1798 9.44447 12.348 9.18316C12.6282 8.74763 12.7907 8.22856 12.7907 7.67442C12.7907 6.13316 11.5413 4.88372 10 4.88372C8.4587 4.88372 7.2093 6.13316 7.2093 7.67442C7.2093 8.18819 7.62578 8.60465 8.13954 8.60465C8.6533 8.60465 9.06977 8.18819 9.06977 7.67442Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIc);
export default __webpack_public_path__ + "static/media/faq_ic.ed1038547d89005131873e8df43683a2.svg";
export { ForwardRef as ReactComponent };